//comment

$(document).ready(function() {
  var dd = new Date();
  var months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  document.querySelectorAll(".mo").forEach(el => {
    el.textContent = months[dd.getMonth()];
  });

  document.querySelectorAll(".da").forEach(el => {
    el.textContent = dd.getDate();
  });

  document.querySelectorAll(".ye").forEach(el => {
    el.textContent = dd.getFullYear();
  });
});

/** PROCEED TO CHECKOUT BTN LOAD **/
$(document).ready(function(){
          $('.cart-right .cart-action button').click(function(){
          $(this).html($(this).html().replace(/Proceed to Checkout/g,"Preparing Checkout <img style='width:18px;' src='https://cdn.shopify.com/s/files/1/0450/6330/7413/files/loading-wt.gif?v=1678974280'>"));
          });
});

function printFunction() {
  try {
    var money = document.querySelector(".docapp-shipping-rate-price .money");
    var free = document.querySelector(".docapp-shipping-rate-price .docapp-free-shipping-amount");

    if (!money && !free) return false;

    var raw =
      money
        ? (money.getAttribute("data-geolizr-price") ||
           money.getAttribute("doubly-currency-usd") ||
           "")
        : "";

    // raw can be "0" for free shipping and still valid
    if (money && raw !== "" && !isNaN(parseInt(raw, 10))) {
      window.print();
      return false;
    }

    var txt = money ? (money.textContent || "").trim() : "";
    if (money && /\d/.test(txt)) {
      window.print();
      return false;
    }

    var freeTxt = free ? (free.textContent || "").trim() : "";
    if (/free/i.test(freeTxt)) {
      window.print();
      return false;
    }

    return false;
  } catch (e) {
    return false;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  try {
    var btn = document.getElementById("printInstantQuoteBtn") || document.querySelector('a[onclick="printFunction()"]');
    if (!btn) return;

    btn.classList.add("print-disabled");

    var tries = 0;
    var iv = setInterval(function () {
      tries++;

      var money = document.querySelector(".docapp-shipping-rate-price .money");
      var free = document.querySelector(".docapp-shipping-rate-price .docapp-free-shipping-amount");

      if (!money && !free) {
        if (tries > 120) clearInterval(iv);
        return;
      }

      var raw =
        money
          ? (money.getAttribute("data-geolizr-price") ||
             money.getAttribute("doubly-currency-usd") ||
             "")
          : "";

      var ready =
        (money && ((raw !== "" && !isNaN(parseInt(raw, 10))) || /\d/.test((money.textContent || "").trim()))) ||
        (free && /free/i.test((free.textContent || "").trim()));

      if (ready) {
        btn.classList.remove("print-disabled");
        clearInterval(iv);
      } else if (tries > 120) {
        clearInterval(iv);
      }
    }, 250);
  } catch (e) {}
});


/** MINIMUM QTY PER PRODUCT **/

document.addEventListener('DOMContentLoaded', function() {
    const updateQuantityControls = () => {
        document.querySelectorAll('.cart-item').forEach(item => {
            // Assume that data-tags attribute contains comma-separated tags
            const tags = item.getAttribute('data-tags').split(',');

            // Find the first tag that starts with 'MIN'
            const minTag = tags.find(tag => tag.trim().startsWith('MIN'));
            const qtyInput = item.querySelector('.input-cart-qty');
            if (minTag) {
                qtyInput.classList.add(minTag.trim());
                const minValue = parseInt(minTag.substring(3), 10); // Extract numeric value

                const currentValue = parseInt(qtyInput.value, 10);
                const downButton = item.querySelector('.qty-down');

                // Predict the next possible value
                const nextValue = currentValue - 1;

                // Update the down button class based on value predictions
                if (nextValue < minValue) {
                    downButton.classList.add('limitreached');
                } else {
                    downButton.classList.remove('limitreached');
                }
            }
        });
    };

    // Initial check and updates
    updateQuantityControls();

    // Event listeners for quantity change buttons
    document.querySelectorAll('.qty-up, .qty-down').forEach(button => {
        button.addEventListener('click', function() {
            const isUp = this.classList.contains('qty-up');
            const input = this.closest('.quantity').querySelector('.input-cart-qty');
            let currentValue = parseInt(input.value, 10);

            // Predict the next value based on button pressed
            currentValue = isUp ? currentValue + 1 : currentValue - 1;

            // Set the predicted value to input temporarily to trigger the logic
            input.value = currentValue;
            updateQuantityControls();

            // Reset the value to original after logic calculation
            input.value = isUp ? currentValue - 1 : currentValue + 1;
        });
    });
});





/** POPUP TO REMOVE ITEM **/
document.addEventListener('DOMContentLoaded', function() {
  // Add event listener to each remove button
  document.querySelectorAll('.cart-remove-btn').forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault();

      // Get the data-tags of the parent cart item row
      var parentRow = button.closest('.cart-item');
      var tags = parentRow.getAttribute('data-tags').split(',');

      // Check if the item has the "Required Addon" tag
      if (!tags.includes("Required Addon")) {
        window.location.href = button.getAttribute('href');
        return;
      }

      // Create and display the modal
      var modal = document.createElement("div");
      modal.id = "removeItemModal";
      modal.style.cssText = "display: flex; position: fixed; z-index: 9999; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgba(0,0,0,0.4); justify-content: center; align-items: center;";
      modal.innerHTML = `
        <div style="background-color: #fff; padding: 20px 20px 30px; border: 1px solid #888; width: 350px; text-align: center; border-radius: 15px;">
          <span id="closeModal" style="color: #aaa; float: right; font-size: 28px; font-weight: bold; cursor: pointer;">&times;</span>
          <p><i class="icon-attention"></i> Attention!<br>Removing this item might affect the functionality of another product.<br><br>Are you sure you want to remove it?</p>
          <a id="confirmRemove" style="padding: 10px 20px; border: 1px solid #000; border-radius: 15px;" href="${button.getAttribute('href')}">Yes</a>
          <span id="cancelRemove" style="margin: 15px; cursor: pointer;">No</span>
        </div>
      `;

      document.body.appendChild(modal);

      // Add event listeners for the modal buttons
      modal.querySelector("#closeModal").onclick = function() {
        modal.remove();
      };
      modal.querySelector("#cancelRemove").onclick = function() {
        modal.remove();
      };
    });
  });
});




/** INTL DISCLAIMER & MIN CART AMOUNT **/
(function() {
  function setupWatcher() {
    var countrySelect = document.querySelector('select[name="shipping_address[country]"]');
    var proceedButton = document.getElementById('proceedToCheckoutButton');
    var minAmountMessage = document.getElementById('CountryMinAmout');
    var minWorld = document.querySelector('.minWorld');
    var minCanada = document.querySelector('.minCanada');
    if (!countrySelect) return;

/* ---------- helper: current cart subtotal in dollars ---------- */
function getCartAmount() {
  /* First try the <strong> element we update in updateCart() */
  var strong = document.querySelector('.cart-total strong');
  if (strong) {
    var n = parseFloat(strong.textContent.replace(/[^0-9.-]+/g, ''));
    if (!isNaN(n)) return n;
  }

  /* Fallback for the wholesale layout you used before */
  var wholesale = document.querySelector('.cart-total .wholesale-cart-total');
  if (wholesale) {
    var m = parseFloat(wholesale.textContent.replace(/[^0-9.-]+/g, ''));
    if (!isNaN(m)) return m;
  }

  /* If both fail, treat it as zero */
  return 0;
}


    function toggleDisclaimerAndCheckout() {
      var disclaimer = document.getElementById('CAcustomsDisclaimer');
      var checkbox = document.getElementById('customsAcknowledgeCheckbox');
      var isNonUS = countrySelect.value !== 'US';
      var isCanada = countrySelect.value === 'CA';
      var cartAmount = getCartAmount();
      var disableCheckout = false;
      var showMessage = false;

      if (isCanada && cartAmount < 1500) {
        disableCheckout = true;
        minCanada.style.display = 'contents';
        minWorld.style.display = 'none';
        showMessage = true;
      } else if (isNonUS && !isCanada && cartAmount < 1500) {
        disableCheckout = true;
        minCanada.style.display = 'none';
        minWorld.style.display = 'contents';
        showMessage = true;
      } else {
        minCanada.style.display = 'none';
        minWorld.style.display = 'none';
        showMessage = false;
      }

      disclaimer.style.display = isNonUS ? 'flex' : 'none';
      proceedButton.disabled = (isNonUS && !checkbox.checked) || disableCheckout;
      minAmountMessage.style.display = showMessage ? 'flex' : 'none';
    }

    function initialToggle() {
      setTimeout(toggleDisclaimerAndCheckout, 500);
    }

    document.addEventListener('change', function(e) {
      if (e.target.id === 'customsAcknowledgeCheckbox' || e.target.matches('.cart-total')) {
        toggleDisclaimerAndCheckout();
      }
    });

    countrySelect.addEventListener('change', toggleDisclaimerAndCheckout);
    initialToggle();
  }

  new MutationObserver(function(mutations, observer) {
    if (document.querySelector('select[name="shipping_address[country]"]')) {
      setupWatcher();
      observer.disconnect();
    }
  }).observe(document.body, { childList: true, subtree: true });
})();






// HIDE/DISPLAY DISCOUNT BANNER AT CHECKOUT
function checkAndShowDiv() {
    const cartTotal = document.querySelector('.cart-total');
    const hiddenDiv = document.querySelector('.limited-time-savings');
    let atLeastOneNotEmpty = false;

    document.querySelectorAll('.list_compared_at_price').forEach(function(element) {
        if (element.textContent.trim().length > 0) {
            atLeastOneNotEmpty = true;
        }
    });

    if (
        (cartTotal && cartTotal.querySelector('.appikon-messages')) || atLeastOneNotEmpty
    ) {
        if (hiddenDiv) {
            hiddenDiv.style.display = 'flex';
        }
    } else {
        if (hiddenDiv) {
            hiddenDiv.style.display = 'none';
        }
    }
}

// Create a MutationObserver to watch for changes in the .cart-total element
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        checkAndShowDiv();
    });
});

// Start observing the .cart-total element for childList changes
const cartTotalElement = document.querySelector('.cart-total');
if (cartTotalElement) {
    observer.observe(cartTotalElement, { childList: true, subtree: true });
}
checkAndShowDiv();

document.addEventListener('DOMContentLoaded', function () {
  enforceAddonRequirements();
});

function enforceAddonRequirements() {
  const rows = Array.from(document.querySelectorAll('tr.cart-item'));
  if (!rows.length) return;

  const skusInCart = new Set(
    rows.map(r => (r.getAttribute('data-sku') || '').trim()).filter(Boolean)
  );

  const keysToRemove = [];

  rows.forEach(row => {
    const key = (row.getAttribute('data-key') || '').trim();
    const tagsStr = row.getAttribute('data-tags') || '';
    const tags = tagsStr.split(',').map(t => t.trim()).filter(Boolean);

    // tag format: requires:sku:BPH660-HP|BPH661-XX
    const reqTag = tags.find(t => t.toLowerCase().startsWith('requires:sku:'));
    if (!reqTag) return;

    const list = reqTag.split('requires:sku:')[1] || '';
    const allowedParents = list.split('|').map(s => s.trim()).filter(Boolean);

    // OR logic: any allowed parent present
    const ok = allowedParents.some(parentSku => skusInCart.has(parentSku));

    if (!ok && key) keysToRemove.push(key);
  });

  if (!keysToRemove.length) return;

  // remove invalid add-ons sequentially
  keysToRemove.reduce((p, key) => {
    return p.then(() => fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }));
  }, Promise.resolve())
  .then(() => window.location.href = '/cart')
  .catch(() => window.location.href = '/cart');
}





/** Function to calculate total discount
document.addEventListener("DOMContentLoaded", function() {
   
    function calculateTotalDiscount() {
        let totalDiscount = 0;
        
        // Get all instances of .list_compared_at_price
        document.querySelectorAll('.list_compared_at_price').forEach(function(comparePriceElement) {
            let comparePriceText = comparePriceElement.textContent.trim();
            if (comparePriceText) {
                let comparePrice = parseFloat(comparePriceText.replace(/[^\d.-]/g, ''));
                let bcpoCartItemPriceElement = comparePriceElement.closest('tr').querySelector('.bcpo-cart-item-price');
                let quantityElement = comparePriceElement.closest('tr').querySelector('.input-cart-qty');
                let quantity = quantityElement ? parseInt(quantityElement.value) : 1;

                if (bcpoCartItemPriceElement) {
                    let itemPrice = parseFloat(bcpoCartItemPriceElement.getAttribute('data-price')) / 100;
                    let discount = (comparePrice - itemPrice) * quantity;
                    if (discount > 0) {
                        totalDiscount += discount;
                    }
                }
            }
        });
        
        // Display the total discount in .OnSaleDiscountJS
        document.querySelector('.OnSaleDiscountJS').textContent = totalDiscount.toFixed(2);
    }
    
    // Call the function to calculate the total discount initially
    calculateTotalDiscount();

    // Create a MutationObserver to watch for changes in the body
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' || mutation.type === 'attributes') {
                calculateTotalDiscount();
            }
        });
    });

    // Configuration for the observer
    const config = {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value']
    };

    // Observe the body for changes
    observer.observe(document.body, config);
});
**/



/** DISPLAY SAVING DISCOUNT AT CART
document.addEventListener('DOMContentLoaded', function() {
    function displaySavingDiscount() {
        const onSaleDiscountElement = document.querySelector('.OnSaleDiscountJS');
        const onSaleDiscount = parseFloat(onSaleDiscountElement.textContent.replace(/[^0-9.-]+/g, ""));

        function createObserver() {
            const observer = new MutationObserver(function() {
                const wholesaleOriginalPriceElement = document.querySelector('.wholesale-original-price');
                const wholesaleCartSubtotalElement = document.querySelector('.wholesale-cart-subtotal');
                if (wholesaleOriginalPriceElement) {
                    const wholesaleOriginalPrice = parseFloat(wholesaleOriginalPriceElement.textContent.replace(/[^0-9.-]+/g, ""));
                    setTimeout(() => {
                        const newPrice = wholesaleOriginalPrice + onSaleDiscount;
                        wholesaleOriginalPriceElement.textContent = `$${newPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

                        if (wholesaleCartSubtotalElement) {
                            const wholesaleCartSubtotal = parseFloat(wholesaleCartSubtotalElement.textContent.replace(/[^0-9.-]+/g, ""));

                            if (!isNaN(wholesaleCartSubtotal)) {
                                const priceDiff = newPrice - wholesaleCartSubtotal;
                                let priceDiffElement = document.querySelector('.price-diff');

                                if (!priceDiffElement) {
                                    priceDiffElement = document.createElement('div');
                                    priceDiffElement.className = 'price-diff';
                                    wholesaleOriginalPriceElement.parentNode.insertBefore(priceDiffElement, wholesaleOriginalPriceElement.nextSibling);
                                }
                                priceDiffElement.textContent = `-$${priceDiff.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                            } else {
                                console.log('Wholesale cart subtotal is not a number.');
                            }
                        } else {
                            console.log('Wholesale cart subtotal element not found.');
                        }
                    }, 100);
                        observer.disconnect();
                    } else {
                        console.log('Wholesale original price is not a number.');
                    }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
        createObserver();
    }

    displaySavingDiscount();

    // Attach event listener to quantity buttons
    const qtyButtons = document.querySelectorAll('.qty-up, .qty-down');
    qtyButtons.forEach(button => {
        button.addEventListener('click', function() {
        setTimeout(() => {
            displaySavingDiscount();
        }, 1000);
        });
    });
}); **/
